import * as React from 'react';
import MuiCheckbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Color, LabelPlacement } from './types';

type Props = {
  checked: boolean;
  color: Color;
  disabled: boolean;
  label: string;
  labelPlacement: LabelPlacement;
  onChange: (checked: boolean) => void;
}

function Checkbox(props: Props) {
  function onChange(event: Object) {
    props.onChange(event.target.checked);
  }

  return (
    <FormControlLabel
      control={
        <MuiCheckbox
          onChange={onChange}
          checked={props.checked}
          color={props.color}
          value={props.value}
        />
      }
      disabled={props.disabled}
      label={props.label}
      labelPlacement={props.labelPlacement}
    />
  );
}

Checkbox.defaultProps = {
  disabled: false,
  checked: false,
  color: 'default',
  labelPlacement: 'end',
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/common/components/ui/Checkbox.js